import { IInitialState } from "us.collection/reducers/ExtendedField/Interfaces";

export const initialState: IInitialState = {
  extendedFields: {
    data: [],
    isFetching: false,
  },
  drawer: {
    title: "",
    visible: false,
    isNewExtendedField: true,
    infoId: -1,
    fieldName:""
  },
  metaData: {
    infoOptions: [],
    isLoading: true,
  },
  isFieldDeleting: false,
  isFieldSaving: false,
};
